var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w100 m-bottom-3",staticStyle:{"border-top":"1px solid #f5f5f5","height":"1px"}})}
var staticRenderFns = []

export { render, staticRenderFns }